import React, { useEffect, useRef, useCallback, useState } from "react";
import { connect, useSelector } from "react-redux";
import { getMatchesList } from "../../../../redux/slices/sportSlice";
import { viewGameStyles as styles } from "./viewGames.tailwind";
// import Spinner from "../../../shared/Loaders/Spinner";
import MatchRow from "./MatchRow";
import no_games_found from '../../../../assets/svgs/no_view_game.svg'
import DateFilters from "../../../PurchaseHistory/DateFilters";
import filter_icon from "../../../../assets/svgs/filter_icon.svg";
import HighlightViewGameModal from "../../../shared/Modals/HighlightViewGameModal/HighlightViewGameModal";
import videoInfo from "../../../../assets/svgs/video_info.svg"
import { Tooltip } from "@mui/material";
import GameScheduleSkeletons from "../../shared/Skeletons/GamesScheduleSkeleton/GameScheduleSkeletons";

const ViewGamesSection = ({ getMatches }) => {
  const apiDataRef = useRef(false);

  const { currentSeason } = useSelector((state) => state.seasons);
  const { matches, matchesLoading } = useSelector((state) => state.sport);

  // Filters
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFilterApplied, setFilterApplied] = useState(false);
  const [isApplyingFilter, setIsApplyingFilter] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [openPreviewVideoModal, setOpenPreviewVideoModal] = useState(false);

  // API call
  const callApi = useCallback(async ({ fromDate, toDate }) => {
    const data = {
      seasonId: currentSeason?._id,
      dateFromFilter: fromDate,
      dateToFilter: toDate,
    };

    await getMatches(data);
    setIsApplyingFilter(false);
  }, [getMatches, currentSeason?._id]);

  // Initial API call
  useEffect(() => {
    if (apiDataRef.current) return;
    apiDataRef.current = true;
    callApi({ fromDate: "", toDate: "" });

    return () => {
      apiDataRef.current = false;
    }
  }, [callApi, currentSeason]);

  const handleFilter = () => {
    setFilterApplied(true);
    setIsApplyingFilter(true);
    callApi({ fromDate, toDate });
  };

  // Clear Filters reset dates to initial state and call API
  const handleClearFilters = async () => {
    setFromDate("");
    setToDate("");

    if (isFilterApplied) {
      callApi({ fromDate: "", toDate: "" });
    }
    setFilterApplied(false);
  };

  // FOR DEMO COMMENTED LINE 68-82

  return (
    <div className={styles.outer_container}>
      {/* {currentSeason?.homeTeam?.teamName && (
        <div className={styles.home_team_info}>
          <span className={styles.team_text}>Home Team:</span>
          {currentSeason?.homeTeam?.teamImage && (
            <img
              src={currentSeason?.homeTeam?.teamImage}
              alt={currentSeason?.homeTeam?.teamName}
              className={styles.home_team_icon}
            />
          )}
          <span className={styles.team_name}>
            {currentSeason?.homeTeam?.teamName}
          </span>
        </div>
      )} */}


      <div className={styles.games_container}>
        {/* Header Section */}
        <div className={styles.header_container}>
          <div className={styles.header_section}>
            <span className={styles.title}>
              Scheduled Games
              <Tooltip title="How to earn points?" arrow>
                <span className="ml-1 cursor-pointer" onClick={() => setOpenPreviewVideoModal(true)}>
                  <img src={videoInfo} alt="" className="w-[20px] sm:w-[25px]" />
                </span>
              </Tooltip>
            </span>

            {/* Filters */}
            <div className="flex gap-2">            
              <button onClick={() => { setShowFilters(prev => !prev) }} className="flex md:hidden">
                <img src={filter_icon} alt="Filter" />
              </button>
            </div>
          </div>

          {/* Date Filters Section */}
          {showFilters && (
            <div className={styles.dateFilterContainer}>
              <DateFilters
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
                isApplyingFilter={isApplyingFilter}
              />
            </div>
          )}
        </div>

        {/* Match Info Section */}
        <div className={styles.match_info_section}>
          {matchesLoading ? (
              <GameScheduleSkeletons />          
          ) : matches?.length > 0 ? (
            <div className={styles.match_detail_container}>
              {/* Matches/ Games List */}
              <div className={styles.dataContainer}>
                {matches?.map((game, key) => (
                  <MatchRow
                    key={key}
                    game={game}
                    seasonId={currentSeason?._id}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.noGamesContainer}>
              <img src={no_games_found} alt="" className="max-w-[180px] w-auto h-auto" />
              <span className={styles.noGamesText}>No Games Scheduled</span>
            </div>
          )}
        </div>
      </div>

      <HighlightViewGameModal isOpen={openPreviewVideoModal} onClose={() => setOpenPreviewVideoModal(false)} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMatches: (data) => dispatch(getMatchesList(data)),
  };
};

export default connect(null, mapDispatchToProps)(ViewGamesSection);
